import { Box, Typography, Link } from "@mui/material";
import NextLink from "next/link";
import { useRouter } from "next/router";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { AuthFormWrapper } from "components/authentication/AuthFormWrapper";
import { ChangePasswordForm } from "components/authentication/change-password";
import { LoginForm } from "components/authentication/login";
import { VerifyCodeStep } from "components/authentication/verify-code";

import { ROUTES } from "constants/routes";
import useAuth from "hooks/useAuth";

const Login: React.FC = () => {
  const [verifying, setVerifying] = React.useState<boolean>(false);
  const [changePassword, setChangePassword] = React.useState<boolean>(false);
  const [loginValues, setLoginValues] = React.useState<{
    email: string;
    password: string;
  }>({ email: "", password: "" });

  const { t } = useTranslation();
  const { user } = useAuth();
  const router = useRouter();

  React.useEffect(() => {
    if (user) {
      router.push("/");
    }
  }, [user, router]);

  return (
    <Box>
      {!changePassword ? (
        <AuthFormWrapper title="Login">
          {verifying ? (
            <VerifyCodeStep loginValues={loginValues} />
          ) : (
            <>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 3,
                }}
              >
                <Box width="100%">
                  <Box display="flex" justifyContent="center">
                    <Typography color="textPrimary" gutterBottom variant="h4">
                      {t("login.title.title")}
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Typography color="textSecondary" variant="body2">
                      {t("login.title.label")}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3,
                }}
              >
                <LoginForm
                  setVerifying={setVerifying}
                  setLoginValues={setLoginValues}
                  setChangePassword={setChangePassword}
                />
                <Box pt={2}>
                  <NextLink href={ROUTES.AUTH_FORGOT_PASSWORD} passHref>
                    <Link color="textSecondary" variant="body2">
                      {t("login.forgot_password")}
                    </Link>
                  </NextLink>
                </Box>
              </Box>
              {/* <Divider sx={{ my: 3 }} />
              <NextLink href={ROUTES.AUTH_REGISTER} passHref>
                <Link color="textSecondary" variant="body2">
                  {t("login.create_account")}
                </Link>
              </NextLink> */}
            </>
          )}
        </AuthFormWrapper>
      ) : (
        <AuthFormWrapper title={t("change_password.title")}>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <div>
              <Typography color="textPrimary" gutterBottom variant="h4">
                {t("change_password.title")}
              </Typography>
              <Typography color="textSecondary" variant="body2">
                {t("change_password.subtitle")}
              </Typography>
            </div>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              mt: 3,
            }}
          >
            <ChangePasswordForm
              email={loginValues.email}
              oldPassword={loginValues.password}
              setLoginValues={setLoginValues}
              setChangePassword={setChangePassword}
            />
          </Box>
        </AuthFormWrapper>
      )}
    </Box>
  );
};
export default Login;
